import { render, staticRenderFns } from "./h5-device.vue?vue&type=template&id=28c59a1b&scoped=true"
import script from "./h5-device.vue?vue&type=script&lang=js"
export * from "./h5-device.vue?vue&type=script&lang=js"
import style0 from "./h5-device.vue?vue&type=style&index=0&id=28c59a1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c59a1b",
  null
  
)

export default component.exports